export default function CreditCardForm({
  form,
  handleFormChange,
  cards,
  cardsLoading,
  cardsError,
  filteredSuggestions,
  focused,
  setFocused,
  hoverIndex,
  setHoverIndex,
  applySuggestion,
}) {


  return (
    <div style={styles.section}>
      <h4 style={{ ...styles.label, marginBottom: '0.5rem' }}>
        Card Directory
      </h4>

      <div style={{ fontSize: 12, color: '#6b7280', marginBottom: 8 }}>
        {cardsLoading
          ? 'Loading cards…'
          : cardsError
            ? cardsError
            : `Loaded ${cards?.length || 0} cards`}
      </div>

      <div style={styles.rowTall}>
        {/* Card Name */}
        <div style={{ ...styles.control, ...styles.suggestWrap }}>
          <label style={styles.label}>Card Name</label>
          <input
            name="heading"
            value={form.heading || ''}
            onChange={handleFormChange}
            onFocus={() => setFocused(true)}
            onBlur={() => setTimeout(() => setFocused(false), 150)}
            placeholder="Start typing to search…"
            style={styles.input}
          />

          {focused && filteredSuggestions?.length > 0 && (
            <div style={styles.suggestList}>
              {filteredSuggestions.map((s, i) => (
                <div
                  key={s.id}
                  style={{
                    ...styles.suggestItem,
                    ...(hoverIndex === i ? styles.suggestItemHover : {}),
                  }}
                  onMouseEnter={() => setHoverIndex(i)}
                  onMouseDown={(e) => {
                    e.preventDefault();
                    applySuggestion(s);
                  }}
                >
                  <img
                    src={s.cardImage || 'https://placehold.co/80x48'}
                    alt=""
                    style={styles.thumb}
                  />
                  <div>
                    <div style={{ fontWeight: 600 }}>{s.name}</div>
                    <div style={{ fontSize: 12, color: '#6b7280' }}>
                      {s.affiliate || '—'} • {s.rating || 0}★
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>

        {/* Affiliate */}
        <div style={styles.control}>
          <label style={styles.label}>Affiliate</label>
          <input
            name="affiliate"
            value={form.affiliate || ''}
            onChange={handleFormChange}
            style={styles.input}
          />
        </div>
      </div>
    </div>
  );
}

/* -------------------- LOCAL STYLES -------------------- */

const styles = {
  section: {
    background: '#ffffff',
    borderRadius: 16,
    padding: 20,
    boxShadow: '0 8px 22px rgba(15,23,42,.08)',
    marginBottom: 24,
  },
  label: {
    fontWeight: 600,
    marginBottom: 6,
    display: 'block',
  },
  input: {
    width: '100%',
    padding: '10px 12px',
    borderRadius: 8,
    border: '1px solid #dbe4f3',
    boxSizing: 'border-box',
  },
  control: {
    flex: 1,
    minWidth: 0,
  },
  rowTall: {
    display: 'flex',
    gap: 16,
    marginTop: 12,
  },
  suggestWrap: {
    position: 'relative',
  },
  suggestList: {
    position: 'absolute',
    top: '100%',
    left: 0,
    right: 0,
    background: '#fff',
    border: '1px solid #e5e7eb',
    borderRadius: 8,
    marginTop: 4,
    maxHeight: 240,
    overflowY: 'auto',
    zIndex: 50,
  },
  suggestItem: {
    display: 'flex',
    gap: 10,
    padding: 10,
    cursor: 'pointer',
  },
  suggestItemHover: {
    background: '#f1f5f9',
  },
  thumb: {
    width: 60,
    height: 36,
    objectFit: 'contain',
  },
};
